<template>
  <div class="profile-popup">
    <div class="profile-popup__wrapp">
      <!-- <ul class="profile-popup__list"> -->
      <!--   <li -->
      <!--     v-for="item of testList" -->
      <!--     :key="item.title" -->
      <!--     class="profile-popup__item" -->
      <!--   > -->
      <!--     <a class="profile-popup__item-link" :href="item.link">{{ -->
      <!--       item.title -->
      <!--     }}</a> -->
      <!--   </li> -->
      <!-- </ul> -->
      <BaseButton
        class="profile-popup__exit-btn"
        tag="button"
        @click="logout"
        >Выйти</BaseButton
      >
    </div>
  </div>
</template>

<script lang="ts">
  import BaseButton from '~/components/BaseComponents/BaseButton.vue';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import { useAuthService } from '~/features/auth/service';

  export default defineNuxtComponent({
    name: 'HeaderProfilePopup',
    components: { BaseButton },
    data: () => ({
      testList: [
        {
          title: 'Посты',
          link: '#',
        },
        {
          title: 'Комментарии',
          link: '#',
        },
        {
          title: 'Избранное',
          link: '#',
        },
        {
          title: 'Настройки',
          link: '#',
        },
      ],
    }),

    computed: {
      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },
    },

    methods: {
      logout() {
        const authService = useAuthService();
        authService.logout();
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '@/components/TheHeader/styles/TheHeader.variables' as *;

  .profile-popup {
    background: $profilePopupBg;
    border-radius: 0 0 32px 32px;
    border: 1px solid $profilePopupBorder;
    border-top: 4px solid $profilePopupBorder;
    // padding: $spacing-2 0;
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.25);
    min-width: 184px;

    &::after {
      position: absolute;
      content: '';
      background-image: url('~/assets/images/svg/popup-triangle.svg');
      top: 1px;
      transform: translateY(-100%);
      width: 43px;
      height: 18px;
      right: 0;
    }

    &__wrapp {
      overflow: hidden;
    }

    &__list {
      border-bottom: 1px solid $headerBorder;
    }

    &__item-link,
    &__exit-btn {
      color: $actionUiColor;
      padding: $spacing-5 $spacing-6;
      font-weight: 500;
      display: block;
      position: relative;
      width: 100%;

      &::before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 32px;
        border: 4px solid $hover-color--1;
        opacity: 0;
        transition: 0.3s opacity ease;
        pointer-events: none;
      }

      @include hover {
        color: $hover-color--2;
        // &::before {
        //   opacity: 1;
        // }
      }
    }
  }
</style>
